import { del, get, post, put } from "../api"
import * as url from "./urls"

const getAllFactories = () => {
  return get(url.GET_ALL_FACTORIES)
}

const getAllFactoriesParanoid = () => {
  return get(url.GET_ALL_FACTORIES_PARANOID)
}

const getFactoryById = id => {
  return get(url.GET_FACTORY_BY_ID.replace(":id", id))
}

const updateSLA = data => {
  return put(url.UPDATE_FACTORIES, data)
}

const deleteFactory = id => {
  const endpoint = url.DELETE_FACTORY_BY_ID.replace(":id", id)
  return del(endpoint)
}

const restoreFactory = id => {
  const endpoint = url.RESTORE_FACTORY_BY_ID.replace(":id", id)
  return post(endpoint)
}

const postNovaFactory = data => {
  return post(url.POST_FACTORY, data)
}

const updateFactory = data => {
  const endpoint = url.UPDATE_FACTORY.replace(":id", data?.id)
  return post(endpoint, data)
}

const getAllSLAFromFactory = id => {
  return get(url.GET_ALL_SLA_FROM_FACTORY.replace(":id", id))
}

const getAllSLAFromFactoryParanoid = id => {
  return get(url.GET_ALL_SLA_FROM_FACTORY_PARANOID.replace(":id", id))
}

const getAllSLAFromFactoryClientParanoid = (id, clientId) => {
  return get(
    url.GET_ALL_SLA_FROM_FACTORY_CLIENT_PARANOID.replace(":id", id).replace(
      ":clientId",
      clientId
    )
  )
}

const postNewSLAForFactory = (id, data) => {
  const endpoint = url.POST_SLA_FOR_FACTORY.replace(":id", id)
  return post(endpoint, data)
}

const updateSLAForFactory = (factoryId, data) => {
  const endpoint = url.UPDATE_SLA_FOR_FACTORY.replace(
    ":factoryId",
    factoryId
  ).replace(":id", data?.id)
  return put(endpoint, data)
}

const deleteSLAFactory = (factoryId, id) => {
  const endpoint = url.DELETE_SLA_FACTORY_BY_ID.replace(
    ":factoryId",
    factoryId
  ).replace(":id", id)
  return del(endpoint)
}

const restoreSLAFactory = (factoryId, id) => {
  const endpoint = url.RESTORE_SLA_FACTORY_BY_ID.replace(
    ":factoryId",
    factoryId
  ).replace(":id", id)
  return post(endpoint)
}

export {
  getAllFactories,
  getFactoryById,
  updateSLA,
  getAllFactoriesParanoid,
  getAllSLAFromFactoryClientParanoid,
  deleteFactory,
  restoreFactory,
  postNovaFactory,
  updateFactory,
  getAllSLAFromFactory,
  getAllSLAFromFactoryParanoid,
  postNewSLAForFactory,
  updateSLAForFactory,
  deleteSLAFactory,
  restoreSLAFactory,
}
